/** Get Filename from given url path */
export const getFileName = (path = '') => (typeof path === 'string' ? path?.split('/')?.pop() : '-');
